var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('site-header',{attrs:{"site-name":_vm.config.site_name,"logo":_vm.config.logo}}),_c('main',{staticClass:"site-main"},[_c('router-view')],1),_c('site-footer',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }